var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pdf-app',{attrs:{"file-name":"polizaGenerada","pdf":_vm.urlPdf}})
}
var staticRenderFns = []

export { render, staticRenderFns }